// Делаем липкую шапку при скролле
$(function() {
    var headerTop;

    // Проверяем, есть ли на странице фильтр. Если есть, то добавляем класс к шапке после прокрутки фильтра. Если нет, то сразу после прокрутки шапки.
    if ($('#filter').length) {
        headerTop = $('#filter').offset().top + 130;
    } else {
        headerTop = $('.header__section').offset().top + 100;
    }

    $(window).scroll(function(){
        if( $(window).scrollTop() > headerTop ) {
            $('.header__section').addClass('header__section_sticky');
        } else {
            $('.header__section').removeClass('header__section_sticky');
            $('.search-window').removeClass('search-window_show');
            $('.header__search').removeClass('header__search_hidden');
        }
    });
})
